<template>
  <!--<div id="THeader">-->
    <!--<Header style="background-color: #ecf0f1">-->
      <!--<Row>-->
        <!--<Col span="4">-->
          <!--<img :src="logoPath"/>-->
        <!--</Col>-->
        <!--<Col push="17" span="3">-->
          <!--<h4>{{userName}}</h4>-->
        <!--</Col>-->
        <!--<Col push="15" span="2" style="text-align: end;margin-top: 0px; padding-right: 0px;color: #0B132B;">-->
          <!--<Icon @click="logout" size="21" style="cursor: pointer;" type="ios-power"></Icon>-->
        <!--</Col>-->
      <!--</Row>-->
    <!--</Header>-->
  <!--</div>-->
</template>

<script>
  export default {
    name: 'THeader',
    props: {
      title: {
        type: String,
        default: 'Tatkal Lorry'
      }
    },
    data () {
      return {
        logoPath: require('../../assets/logo.png'),
      }
    },
    computed: {
        userName: function(){
            return this.$store.state.userObj?this.$store.state.userObj.user.name : ''
        }
    },
      methods: {
      logout () {
        this.$Modal.confirm({
          title: 'Logout',
          content: '<p>Are you Sure, you want to Logout?</p>',
          onOk: () => {
            localStorage.clear()
            this.$Message.warning('Successfully Logout')
            this.$router.go()
          }
        })
      }
    },
  }
</script>

<style scoped>

</style>
